import styled from "styled-components";

const theme = {
  sungsim: {
    ref: { base: "#2a3341", hover: "#4f78b8" },
    room: { base: "#FFE072", hover: "#ff8a00" },
    car: { base: "#cdb5f5", hover: "#a976ff" },
  },
  baseball: {
    ref: { base: "#FFCC00", hover: "#fff8de" },
    room: { base: "#253f85", hover: "#8ca5e7" },
    car: { base: "#b24d4d", hover: "#f4a5a5" },
  },
};

export const KioskPickUp = styled.div`
  padding: 20px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
  &.baseball {
    .pickupReqButton button {
      color: #000;
      background: ${theme.baseball.ref.base};
    }
  }
  &.sungsim {
    .pickupReqButton button {
      background: ${theme.sungsim.ref.base};
    }
  }
  .pickupReqButton {
    text-align: right;
    margin-bottom: 10px;
    button {
      background: rgb(42, 51, 65);
      color: rgb(255, 255, 255);
      border: none;
      border-radius: 31px;
      font-size: 24px;
      font-weight: 700;
      width: 200px;
      height: 50px;
      text-align: center;
    }
  }
  .content {
    height: calc(100% - 150px);
    width: 100%;
    overflow: auto;
    position: relative;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
  }
  @media screen and (max-width: 1050px) {
    .content {
      height: calc(100% - 200px);
    }
    .pickupReqButton {
      button {
        font-size: 18px;
        width: 160px;
        height: 40px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .content {
      height: calc(100% - 150px);
    }
    .pickupReqButton {
      button {
        width: 140px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
`;

export const EditPickupModal = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  .slideWrapper {
    flex-flow: row nowrap;
    display: flex;
    flex: 1;
    width: 100%;
    transition: transform 0.5s ease;
    height: 100%;
    overflow: hidden;
    margin: auto;
  }
  .slideContent {
    flex: 0 0 50%;
    height: 100%;
    position: relative;
    transform: translateX(0);
    flex-basis: 100%;
    flex-shrink: 0;
    transition: 0.3s;
    width: 100%;
  }
`;

export const Tabs = styled.ul`
  display: flex;
  align-items: center;
  li {
    width: calc(100% / 3);
    height: 9.5238vh;
    background: #d9d9d9;
    color: #4d4d4d;
    font-size: 3.8095vh;
    text-align: center;
    line-height: 9.5238vh;
    font-weight: 700;
    transition: 0.3s;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.refrigerated {
      color: #fff;
      background: ${theme.sungsim.ref.base};
    }
    &.roomTemperature {
      background: ${theme.sungsim.ref.room};
    }
    &.carrier {
      background: ${theme.sungsim.ref.car};
    }
    &.all {
      background: #333;
      color: #fff;
    }
  }
  @media screen and (max-width: 767px) {
    li {
      height: 6.5741vh;
      line-height: 6.5741vh;
      font-size: 2.7778vh;
    }
  }
`;

export const StorageDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  &.between {
    justify-content: space-between;
  }
  &.center {
    justify-content: center;
    gap: 30px;
  }
  .modalTit {
    font-size: 40px;
    font-weight: 700;
  }
  .paymentMethod {
    .con {
      display: flex;
      gap: 10px;
      align-items: center;
      label {
        height: 35px;
        width: 35px;
        position: relative;
        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          padding: 0;
          width: 0;
          height: 0;
        }
        .checkmark {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          border: 2px solid #d4d4d4;
          border-radius: 10px;
          background-color: transparent;
          transition: all 0.3s ease;
          &:after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg) scale(0);
            opacity: 0;
            width: 13px;
            height: 24px;
            border: solid #fff;
            border-width: 0px 3px 3px 0px;
            transition: 0.3s;
          }
        }
        input:checked ~ .checkmark {
          background: ${theme.sungsim.ref.base};
          border: 1px solid ${theme.sungsim.ref.base};
          &:after {
            opacity: 1;
            transform: translate(-50%, -65%) rotate(45deg) scale(1);
            border-color: #fff;
          }
        }
        &:hover .checkmark {
          background-color: #efefef;
        }
      }
      label + span {
        margin-right: 10px;
      }
    }
  }
  .userInfo {
    font-size: 24px;
    width: calc(100% - 40px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .actions {
      font-size: 20px;
      display: flex;
      gap: 10px;
      label {
        input {
          display: none;
        }
        span {
          background: #d9d9d9;
          color: #4d4d4d;
          border-radius: 20px;
          width: 100px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        input:checked + span {
          background: #636e81;
          color: #fff;
        }
      }
      button {
        background: #2a3341;
        color: #fff;
        border-radius: 20px;
        width: 100px;
        height: 50px;
        border: none;
        font-weight: 700;
      }
    }
  }
  .storages {
    width: 100%;
    height: calc(100% - 220px);
    overflow-y: auto;
    font-size: 20px;
    .content {
      height: auto;
      max-height: none;
      .content {
        padding: 0;
      }
      h3 {
        border-left: 5px solid;
        padding-left: 5px;
        margin: 10px 0 5px;
        font-size: 24px;
      }
      &.refrigerated h3 {
        border-color: ${theme.sungsim.ref.base};
      }
      &.roomTemperature h3 {
        border-color: ${theme.sungsim.ref.room};
      }
      &.carrier h3 {
        border-color: ${theme.sungsim.ref.car};
      }
    }
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
    .userStorage > li {
      width: 49%;
      margin-bottom: 2%;
      border: 3px solid ${theme.sungsim.ref.base};
      padding: 5px;
      position: relative;
      border-radius: 10px;
      display: inline-block;
      &:nth-child(odd) {
        margin-right: 2%;
      }
      ul {
        width: calc(100% - 40px);
        li {
          span {
            display: inline-block;
          }
          .tit {
            width: 150px;
          }
          .con {
            width: calc(100% - 150px);
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 20px;
    .modalTit {
      font-size: 24px;
    }
    .content {
      padding: 0;
    }
    .userInfo {
      flex-direction: column;
      width: 100%;
      align-items: baseline;
      font-size: 20px;
      ul {
        width: 100%;
        font-size: 14px;
      }
      .actions {
        width: 100%;
        margin-top: 10px;
        justify-content: end;
        label span,
        button {
          height: 30px;
          font-size: 14px;
          width: auto;
          padding: 0 5px;
        }
      }
    }
    .storages {
      .content {
        max-height: none;
      }
      .userStorage > li {
        width: 100%;
        font-size: 18px;
        &:nth-child(2n + 1) {
          margin-right: 0;
        }
      }
    }
    .radioBox {
      width: 80vw;
      label {
        width: calc(50% - 10px);
        span {
          display: block;
          padding: 15px 0;
          text-align: center;
        }
      }
    }
  }
`;
